module.exports = __webpack_public_path__ + "static/warre-7be5eca26fbb37fc19900de77ff2a332.jpg";